import LoadingSlots from "@components/Booking/SlotPicking/components/SlotLoader";
import Slot from "@components/Booking/SlotPicking/Slot";
import {ApptSlot} from "@services/monolith/availability";
import React from "react";

type SlotGridProps =
  | {
      onSlotSelection: (slot: ApptSlot) => void;
      selectedSlotTime?: number;
      slots: ApptSlot[];
      timezone: string;
      loading?: boolean;
      disabled?: boolean;
    }
  | {
      onSlotSelection?: (slot: ApptSlot) => void;
      selectedSlotTime?: number;
      slots?: ApptSlot[];
      timezone?: string;
      loading: true;
      disabled?: boolean;
    };

const SlotGrid = ({
  onSlotSelection,
  selectedSlotTime,
  slots,
  timezone,
  loading,
  disabled,
}: SlotGridProps) => {
  return (
    <div className="grid grid-cols-3 sm:grid-cols-4 gap-2 w-full">
      {loading ? (
        <LoadingSlots />
      ) : (
        slots.map(slot => (
          <Slot
            key={slot.id}
            onClick={() => {
              onSlotSelection(slot);
            }}
            selected={slot.time === selectedSlotTime}
            time={slot.time}
            timezone={timezone}
            disabled={disabled}
          />
        ))
      )}
    </div>
  );
};

export default React.memo(SlotGrid);
